<template>
  <div class="bg-lightGray page-responses mainPad">
    <div class="container">
      <div class="row">
        <div class="col-md-12 pt-0 pb-0">
          <nav area-label="breadcrumb">
            <ol class="breadcrumb" style="font-size: 14px">
              <li class="breadcrumb-item"><a href="/recruit">Home</a></li>
              <li class="breadcrumb-item"><a href="/recruit/client-job-dashboard">Dashboard</a></li>
              <li class="breadcrumb-item active" aria-current="page">Job responses</li>
            </ol>
          </nav>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-lg-8 col-md-8 col-sm-8 col-6 pb-0"><h1>Manage job response</h1></div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-6 pb-0 text-right">
          <button class="btn btn-outline-primary" type="submit">Post Jobs</button>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-2 order-lg-1 mb-2">
          <vue-sticky-sidebar class="sidebar" containerSelector=".StKcontainer" innerWrapperSelector=".sidebar__inner">
            <nav>
              <div class="nav nav-tabs leftTabs" id="nav-tab" role="tablist">
                <a class="nav-link text-right bg-white" :class="current_tab == 'all' ? 'active' : ''" id="nav-home-tab all" data-toggle="tab" role="tab" aria-controls="nav-home" aria-selected="true" v-on:click="filterStatus(null, 'all')" >All<Span class="responsNotification bgBlue style2">{{total_count}}</Span></a>
                <a class="nav-link text-right bg-white" :class="current_tab == 'applied' ? 'active' : ''" id="nav-home-tab applied" data-toggle="tab" role="tab" aria-controls="nav-home" aria-selected="true" v-on:click="filterStatus(0, 'applied')" >Applied<Span class="responsNotification bgBlue style2">{{no_applied}}</Span></a>
                <a class="nav-link text-right bg-white" :class="current_tab == 'shortlisted' ? 'active' : ''" id="nav-home-tab shortlisted" v-on:click="filterStatus(1, 'shortlisted')">Shortlisted<Span class="responsNotification bgligtgray style2">{{ no_shortlisted }}</Span></a>
                <a class="nav-link text-right bg-white" :class="current_tab == 'interviewed' ? 'active' : ''" id="nav-home-tab interviewed" v-on:click="filterStatus(2, 'interviewed')">Interviewed<Span class="responsNotification bgligtgray style2">{{ no_interviewed }}</Span></a>
                <a class="nav-link text-right bg-white" :class="current_tab == 'offered' ? 'active' : ''" id="nav-home-tab offered" v-on:click="filterStatus(3, 'offered')" >Offered<Span class="responsNotification bgligtgray style2">{{no_offered}}</Span></a>
                <a class="nav-link text-right bg-white" :class="current_tab == 'rejected' ? 'active' : ''" id="nav-home-tab rejected" v-on:click="filterStatus(4, 'rejected')">Rejected<Span class="responsNotification bgligtgray style2">{{ no_rejected }}</Span></a>
                <a class="nav-link text-right bg-white" :class="current_tab == 'joined' ? 'active' : ''" id="nav-home-tab joined" v-on:click="filterStatus(5, 'joined')">Joined<Span class="responsNotification bgligtgray style2">{{no_joined}}</Span></a>
                <!-- <a class="nav-link text-center bg-white" id="nav-profile-tab" data-toggle="tab" role="tab" aria-controls="nav-profile" aria-selected="false" v-on:click="getDBMatchProfiles">DBMatch profile<br><span>{{dbmatch_profiles}}</span></a> -->
              </div>
            </nav>
            <nav class="mt-1">
              <div class="nav nav-tabs leftTabs" id="nav-tab" role="tablist">
                <a class="nav-link text-right bg-white" :class="current_tab == 'starred' ? 'active' : ''" id="nav-home-tab starred" data-toggle="tab" role="tab" aria-controls="nav-home" aria-selected="true" v-on:click="getStarred()" >Starred<Span class="responsNotification bgBlue style2">{{no_starred}}</Span></a>
                <!-- <a class="nav-link text-center bg-white" id="nav-profile-tab" data-toggle="tab" role="tab" aria-controls="nav-profile" aria-selected="false" v-on:click="getDBMatchProfiles">DBMatch profile<br><span>{{dbmatch_profiles}}</span></a> -->
              </div>
            </nav>
          </vue-sticky-sidebar>
        </div>
        
        <div class="col-lg-10 order-lg-1 mb-2 StKcontainer" id="content">
          <div class="jobHead">
            <div class="col-lg-12 p-0 pb-3">
              <div class="row">
                <div class="col-lg-12" v-if="job">
                  <h2>{{ job.designation }}</h2>
                  <p class="mb-0 jobFeature">
                    <span class="txt-blue"> Job ID: {{ job.job_id }}</span>
                    <span class="txt-green"> {{ job.status }} </span>
                    <span> Free Job</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-content" id="nav-tabContent">
            <div class="tab-pane fade show active" id="nav-home jobResponse" role="tabpanel" aria-labelledby="nav-home-tab">
              <div class="mb-2">
                <div class="col-lg-12 profileAction">
                  <div class="row">
                    <div class="col-lg-1 col-2 col-md-2 col-sm-2 col-xs-2 proAction">
                      <v-checkbox v-model="selectAll" @change="select_All($event)">
                      </v-checkbox>
                    </div>
                    <div class="col-lg-11 col-10 col-md-10 col-sm-10 col-xs-10 text-right">
                      <button class="btn actBtn" @click="downloadResponses()"><i class="mdi mdi-file-download"></i> Download</button>
                      <button class="btn actBtn" @click="openEmailPopup()"> <i class="mdi mdi-email-send"></i> Email</button>
                      <button class="btn actBtn" @click="openAssessmentPopup()"><i class="mdi mdi-email-send"></i> Assessment</button>
                    </div>
                  </div>
                </div>
                <div class="row responses-filter-row">
                  <div class="col-lg-3 mb-lg-3" v-if="dealBreaker.length"><v-select class="resp-filter" v-model="deal" :items="dealBreaker" label="Screener question" item-value="qid" item-text="question" @input="applyQuestionnaireFilter" clearable outlined></v-select></div>
                  <div class="col-lg-3 mb-lg-3">
                      <v-autocomplete class="resp-filter" v-model="req.course_id" multiple @change="loadResponses"  :items="courses" item-value="value" item-text="text"  small-chips outlined deletable-chips><template #label>Highest qualification</template></v-autocomplete>
                  </div>
                  <div class="col-lg-3 mb-lg-3">
                      <v-autocomplete class="resp-filter"  v-model="req.city_id" multiple @change="loadResponses" :items="locations" item-value="value" item-text="text"  small-chips outlined deletable-chips><template #label>Location</template></v-autocomplete>
                  </div>
                  <div class="col-lg-3 mb-lg-3" v-if="load_more">
                    <v-autocomplete class="resp-filter" v-model="req.min_passout"  @input="loadResponses"  :items="years" item-value="value" item-text="text"  small-chips outlined deletable-chips><template #label>Passout from</template></v-autocomplete>
                  </div>
                  <div class="col-lg-3 mb-lg-3" v-if="load_more">
                    <v-autocomplete class="resp-filter" v-model="req.max_passout"  @input="loadResponses"  :items="years" item-value="value" item-text="text"  small-chips outlined deletable-chips><template #label>Passout to</template></v-autocomplete>
                  </div>
                  <div class="col-lg-3 mb-lg-3 pt-0" v-if="load_more">
                    <v-text-field class="resp-filter" outlined type="number"  @input="loadResponses" v-model="req.min_agg_marks" placeholder="Highest qualification% from"></v-text-field>
                  </div>
                  <div class="col-lg-3 mb-3">
                    <button class="btn btn-outline-primary" v-if="!load_more" @click="load_more = true">Load more</button>
                    <button class="btn btn-outline-primary" v-else @click="load_more = false">Load less</button>
                    <button class="btn btn-outline-primary ml-2" @click="loadResponses()">Search</button>
                  </div>
                </div>

                <div class="card candidate" v-for="(response, index) in responses" v-bind:key="response.application_id">
                  <div class="row">
                    <div class="col-md-2">
                      <span class="checkB">
                        <input class="mr-2" type="checkbox" name="" ref="index" v-model="selected[parseInt(index) + parseInt(offset)]" @input="getSelected($event,parseInt(index) + parseInt(offset))"/>
                      </span>
                      <div class="userDp">
                        <div class="video-input mt-2"><span class="userDummy"></span></div>
                      </div>
                    </div>
                    <div class="col-md-10 mobInfo">
                      <div class="card-header bg-white">
                        <div class="row">
                          <div class="col-lg-6">
                            <h6>
                              <a :href="'/recruit/candidate-dashboard/' +response.candidate_id +'/'+job.job_id+'?key=' +response.job_key +'&client=' +response.client_key" target="_blank" v-if="response.candidate_name">{{ response.candidate_name }}</a><span><i v-if="response.starred" @click="starApplicant(response.application_id,index, 0)" class="mdi mdi-star ml-1 text-warning"></i><i v-else @click="starApplicant(response.application_id,index, 1)" class="mdi mdi-star-outline ml-1 text-warning"></i></span>
                              <b-badge variant="primary" v-if="response.src == 'jobfair'" class="ml-1"><span>Jobfair applicant</span></b-badge>
                            </h6>
                            <p class="candiateMainInfo"><span class="location" v-if="response.city_name"><i class="mdi mdi-earth"></i>{{ response.city_name }}</span></p>
                          </div>

                          <!-- <b-btn >Launch Modal</b-btn> -->
                          <b-modal :id="'visume_mode' + response.application_id" ref="visume_mode" title="Visume" hide-footer no-close-on-backdrop centered>
                            <form ref="addVisume-form" action="">
                              <div id="interactive" class="viewport">
                                <div>
                                  <video id="video_resume" width="460" height="345" controls v-if="response.video_resume_path" :src="$S3_bucket_url+response.video_resume_path"></video>
                                  <div v-if="!response.video_resume_path" style="margin: 100px">
                                    <h4 style="color: #b1b1b1"><strong>Visume not uploaded</strong></h4>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </b-modal>
                          <div class="col-lg-6 text-right dateMobile">
                            <div>
                              <button class="assess_badge px-2 mr-1" @click="getApplicantAssessments(response.candidate_id, 1)" v-if="getAssessmentStatus(response.assessment_invite_count, 1)">Assessment score</button>
                              <button class="assess_badge px-2" @click="getApplicantAssessments(response.candidate_id,0)" v-if="getAssessmentStatus(response.assessment_invite_count, 0)">Assessment sent</button>
                            </div>
                            <p class="apllyDate" v-if="response.applied_date">Applied: {{response.applied_date}}</p>
                          </div>
                        </div>
                      </div>

                      <div class="card-body">
                        <div class="row">
                          <div class="col-md-12">
                            <div>
                              <span class="rInfo2" v-if="response.role"><b>Job role:</b> {{ response.role }}</span>
                              <span class="rInfo2" v-if="response.total_experience"><b>Experience :</b>{{ getExp(response.total_experience) }}</span>
                              <span class="rInfo2" v-if="response.course_name || response.branch_name"><b>Education :</b> {{ response.course_name}}<span v-if="response.branch_name">/ </span>{{ response.branch_name}}<span v-if="response.passout_year">-</span>{{ response.passout_year}}<span v-if="response.mark_type"> with </span>{{ response.mark_type }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-8 RVisume text-left">
                            <p v-if="response.resume_path"><a :href="$S3_bucket_url+response.resume_path"><i class="mdi mdi-download" data-toggle="tooltip" data-placement="top" title="" data-original-title="Download resume"></i>Resume</a></p>
                            <p v-if="response.video_resume_verified"><a href="#" v-b-modal="modalId(response.application_id)" data-toggle="modal" :data-target="'#myModal' + response.application_id"><i class="mdi mdi-message-video" data-toggle="tooltip" data-placement="top" title="" data-original-title="View visume"></i>Visume</a></p>
                            <p><a href="#" data-toggle="modal" data-target="#contact" @click="viewContact(response)" ><i class="mdi mdi-comment-account-outline" data-toggle="tooltip" data-placement="top" title="" data-original-title="View visume"></i>View contact</a></p>
                            <p><a href="#" data-toggle="modal" data-target="#questionnare" @click="viewQuestionnare(response)"><i class="mdi mdi-message-text" data-toggle="tooltip" data-placement="top" title="" data-original-title="View questionnaire"></i>View Questionnaire </a></p>
                            <p class="mb-0 p-0"><ScheduleInterview :response="response" :job="job"/></p>
                          </div>
                          <div class="col-lg-4 RVisume text-right">
                            <div class="d-flex">
                              Status:
                              <b-form-select v-model="response.application_status" class="pt-0 ml-3 statusBox" @change.native="updateStatus($event, response.application_id)">
                                <option value="0">Applied</option>
                                <option value="1">Shortlisted</option>
                                <option value="2">Interviewed</option>
                                <option value="3">Offered</option>
                                <option value="4">Rejected</option>
                                <option value="5">Joined</option>
                              </b-form-select>
                            </div>
                            <div class="d-flex mt-lg-5 pt-0 align-items-center justify-content-end">
                              <Rating :grade="response.rating" :application_id="response.application_id"/> 
                              <div class="ml-5" v-if="!response.comment">
                                <a @click="response.hide_comment = false;" style="color:#1976d2;">Comment</a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="comment mt-3 d-flex justify-content-between align-items-center px-5 py-1" v-if="!response.edit_comment && response.comment">
                          <div>
                            <div>{{response.comment}}</div>
                            <div class="commented_on">- Commented on {{getDateWithTime(response.commented_on)}}</div>
                          </div>
                          <div @click="response.edit_comment = true;"><span class="fa fa-edit"></span></div>
                        </div>
                        <div class="d-flex" v-if="!response.hide_comment || response.edit_comment">
                          <input class="form-control fields col-lg-8" type="text" v-model="response.comment_text" placeholder="Enter your comment here"/>
                          <button class="col ml-2 btn btn-primary" @click="postComment(response.application_id,index, response.comment_text)">Post</button>
                          <button class="col ml-2 btn btn-primary" @click="cancelComment(index)">Cancel</button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Modal -->
                  <div class="modal fade" id="contact" tabindex="-1" aria-labelledby="contact" aria-hidden="true">
                    <div class="modal-dialog">
                      <div class="modal-content">
                        <div class="modal-body">
                          <p>Looks like Your package is expired!.</p>
                          <button type="button" class="btn btn-primary float-right" data-dismiss="modal">Ok</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="responses.length" class="justify-content-between align-items-center d-flex">
                  <div>
                    <div class="col pl-6">showing results
                      <span>{{ (page - 1) * limit + 1 }}</span> -
                      <span>{{ job_responses > (page - 1) * limit + limit ? (page - 1) * limit + limit : job_responses}}</span>of 
                      <span>{{ job_responses }}</span>
                    </div>
                    <div class="col pt-0">
                      <v-pagination v-model="page" :length="length" class="float-left" @input="handlePageChange"></v-pagination>
                    </div>
                  </div>
                  <div>
                    <span class="text-right">Result Per Page:</span>
                    <b-form-select class="col-4 pt-0" v-model="limit" :options="paginate_options" @change="page = 1;offset = 0;loadResponses()"></b-form-select>
                  </div>
                  <div>
                    <span class="text-right">Result Per Page:</span>
                    <b-form-select class="col-4 pt-0" v-model="limit" :options="paginate_options" @change="page = 1; offset = 0;loadResponses()"></b-form-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="update-success" size="sm" title=" " body-bg-variant="primary" bod body-text-variant="light" hide-footer hide-header hide-backdrop centered>
      <div class="container text-center">Application status updated</div>
    </b-modal>
    <b-modal id="view-contact" ref="view-contact" size="sm" bod title="Contact Details" hide-footer hide-backdrop centered>
      <ContentLoader viewBox="0 0 250 110" v-if="contact_loading">
        <rect x="0" y="0" rx="3" ry="3" width="250" height="10" />
        <rect x="20" y="20" rx="3" ry="3" width="220" height="10" />
        <rect x="20" y="40" rx="3" ry="3" width="170" height="10" />
        <rect x="0" y="60" rx="3" ry="3" width="250" height="10" />
        <rect x="20" y="80" rx="3" ry="3" width="200" height="10" />
        <rect x="20" y="100" rx="3" ry="3" width="80" height="10" />
      </ContentLoader>
      <div v-else>
        <div class="container text-left" v-if="contact_remaining !== 0">
          <p>Views remaining: {{contact_remaining}}</p>
          <p>Name : {{contact.name}}</p>
          <p>Email : {{contact.email}}</p>
          <p>Mobile : {{contact.mobile}}</p>
        </div>
        <div v-else>
          <p v-if="high_usage">We have found  higher usage in your account.For security reasons we are deactivating your package.If this usage from your side, please contact admin at <a href="mailto:recruit@hireclap.com">recruit@hireclap.com</a> to activate your package </p>
          <p v-else>Credits expired <br> <a href="/recruit/package-pricing" target="noopener">Subscribe</a> for more contact access </p>
        </div>
      </div>
    </b-modal>
    <b-modal id="view-assessment" ref="view-assessment" size="md" bod :title="assess_modal_title" hide-footer  hide-backdrop centered>
      <div v-if="assess_details.length > 0">
        <div class="container text-left">
          <div v-for="(assess,i) in assess_details" :key="i">
            <p><strong>{{ assess.test_name }}</strong></p>
            <div v-if="assess.status">
              <p class="mb-0">Score: {{assess.score}} out of {{assess.total_marks}}</p>
              <p class="mb-0">Attempted on: {{getDateWithTime(assess.test_taken_on)}}</p>
              <p><span><a :href="qa_link+'/view-result-report/'+assess.assess_candidate_id+'/1'" target="noopener">View result</a></span> | <span><a :href="qa_link+'/download-pdf-report/'+assess.assess_candidate_id+'/1'" target="noopener">Download result</a></span></p>
            </div>
            <div v-else>
              <p>Sent on {{getDateWithTime(assess.sent_on)}}</p>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal id="questionnare" ref="questionnare" size="lg" bod title="Questionnaire Result" hide-footer  hide-backdrop centered >
      <div class="container" v-if="!loading">
        <div v-if="!questionnaire_results.length">
          <p class="text-center">No Results</p>
        </div>
        <div v-else>
          <div v-for="(result,index) in questionnaire_results" v-bind:key="index">
            <p>{{index+1}}. {{result.question}}</p>
            <p v-if="result.qp_id == 3">ans: <a :href="$S3_bucket_url+result.answer_text" v-if="result.answer_text" target="_blank">Download</a></p>
            <p v-else-if="result.question_type == 7">ans: <button v-if="result.answer_text" class="btn btn-success" type="button" @click="playVideo($S3_bucket_url+result.answer_text)">Play</button></p>
            <p v-else>ans : <span v-if="result.answer_text">{{result.answer_text}}</span><span v-else>{{result.answer}}</span></p>
          </div>
        </div>
      </div>
      <div class="loader" v-if="loading">
          <PreLoader></PreLoader>
      </div>
    </b-modal>
    <b-modal id="email-subscribe" hide-header hide-footer size="md" centered>
      <a href="/recruit/package-pricing" target="noopener">Subscribe</a> to send emails
      <div>
        <button class="btn btn-primary float-right" @click="$bvModal.hide('email-subscribe')">ok</button>
      </div>
    </b-modal>
    <b-modal id="download-subscribe" hide-header hide-footer size="md" centered>
      <div>Credits expired<br> <a href="/recruit/package-pricing" target="noopener">Subscribe</a> for more downloads</div>
      <div>
        <button class="btn btn-primary float-right" @click="$bvModal.hide('download-subscribe')">ok</button>
      </div>
    </b-modal>
    <b-modal id="video_modal" ref="video_modal" title="Video" hide-footer centered no-close-on-backdrop>
      <div id="interactive" class="viewport">
        <div class="text-center">
          <video :src="video" controls style="width:100%;height:100%;"></video>
        </div>
      </div>
    </b-modal>
    <SendMailPopup :responses="responses" :job="job" :selected="selected" :getEmailQuota="getEmailQuota" :email_remaining="email_remaining" :recipients="recipients"></SendMailPopup>
    <SendAssessmentPopup :responses="responses" :job="job" :selected="selected" :recipients="recipients" :loadResponses="loadResponses"></SendAssessmentPopup>
  </div>
</template>

<script>
const Rating = () => import(/* webpackPrefetch: true */ "@/components/Rating");
const ScheduleInterview = () => import(/* webpackPrefetch: true */ "@/components/ScheduleInterview");
const SendAssessmentPopup = () => import(/* webpackPrefetch: true */ "@/components/SendAssessmentPopup");
const SendMailPopup = () => import(/* webpackPrefetch: true */ "@/components/SendMailPopup");
const PreLoader = () => import(/* webpackPrefetch: true */ "@/components/PreLoader");
import XLSX from "xlsx";
import { ContentLoader } from "vue-content-loader";

export default {
  name: "job_responses",
  components: {
    ScheduleInterview,
    SendMailPopup,
    ContentLoader,
    PreLoader,
    SendAssessmentPopup,
    Rating
  },
  beforeMount(){
    window.scrollTo(0, 0);
    this.loadResponses();
    this.getStates();
    this.loadYears();
    this.getCourses();
    this.getEmailQuota();
    this.getContactQuota();
    this.getJobrole();

    var emp_token = this.$cookies.get("hire-employer").token;

    new this.$apiAction().getEmployer(emp_token).then((res) => {
      this.employer = res.data;
    }).catch((err) => {
      console.log(err);
    });
    this.dealBreakerQuestions();
  },
  watch: {
    resp_arr: function (newValue) {
      this.recipients[this.page - 1] = newValue;
    }
  },
  computed: {
    resp_arr: function () {
      let selected_ids = [];
      this.selected.slice(this.offset, parseInt(this.offset) + parseInt(this.limit)).forEach((id, index) => {
          if (id == true) {
            selected_ids.push(index);
          }
        });
      let cids = [];
      this.responses.forEach((response, index) => {
        if (selected_ids.includes(index)) {
          cids.push(response["candidate_id"]);
        }
      });
      return cids;
    },
  },
  data(){
    return{
      job_responses : 0,
      dbmatch_profiles:0,
      jf_application_count:0,
      params: '',
      selected:[],
      recipients: [],
      selectAll: false,
      job:null,
      responses:[],
      employer:null,
      current_tab:'applied',
      contact:{},
      deal:null,
      high_usage: false,
      paginate_options: [
          { text: '25', value: 25 },
          { text: '50', value: 50 },
          { text: '100', value: 100 },
          { text: '200', value: 200 },
      ],
      visume_filter: false,
      status_filter : 0,
      jobfair_src: false,
      length: 0,
      email_remaining: 0,
      contact_remaining: 0,
      page:1,
      offset: 0,
      limit: 25,
      contact_loading:false,
      gender:{
        options:[
          {value:1, text:'Male'},
          {value:2, text:'Female'},
          {value:3, text:'Both'}
        ]
      },
      total_count:0,
      no_shortlisted: 0, 
      no_interviewed: 0,
      no_offered: 0,
      no_rejected: 0,
      no_joined: 0,
      no_starred: 0,
      questionnaire_results: [],
      dealBreaker: [],
      response_data: [],
      no_applied :0,
      assess_details: [],
      assess_modal_title:'',
      loading:false,
      load_more: false,
      years:[],
      locations: [],
      courses: [],
      jobroles:[],
      req : {
        all: '',
        offset: null,
        limit: null,
        status: 0,
        course_id: [],
        city_id: [],
        min_agg_marks:null,
        min_passout: null,
        max_passout: null
      },
      qa_link: process.env.VUE_APP_ASSESSMENT_URL,
      video:null
    }
  },
  methods:{
    openModal: function (type = "") {
      this.open = (type == "")? this.open : type;
      if (this.open == "view") {
        this.$refs["view-contact"].show();
      }
      if(this.open == "questionnare"){
        this.$refs["questionnare"].show();
      }
    },
    playVideo(video){
      this.$refs['video_modal'].show();
      this.video = video;
    },
    postComment(id, i, comment){
      var token = this.$cookies.get("hire-employer").token;
      this.responses[i].comment = comment;
      new this.$apiAction().updateComment(id, token, { comment }).then(() => {
        this.responses[i].edit_comment = false;
        this.responses[i].hide_comment = true;
        this.loadResponses();
      });
    },
    starApplicant(id, i, starred){
      var token = this.$cookies.get("hire-employer").token;
      this.responses[i].starred = starred;
      new this.$apiAction().starApplicant(id, token, { starred }).then(() => {
        this.loadResponses();
      });
    },
    cancelComment(i){
      this.responses[i].comment_text = this.responses[i].comment;
      this.responses[i].edit_comment = false;
      this.responses[i].hide_comment = true;
    },
    getStates: async function () {
          await new this.$apiAction().getStates().then(async (data) => {
              this.locations.push({header: 'Top Metropolitan Cities'})
              await data.states.forEach(async (element) => {
                  await element.cities.forEach(city => {
                      if(city.top_city == 1){
                          this.locations.push({text:city.city_name,value:city.city_id, s_id:city.state_id,group:'Top Metropolitan Cities'})
                      }
                  });
                  this.locations.push({divider:true})
                  this.locations.push({header: element.state_name});
                  element.cities.forEach(city => {
                      if(city.top_city == 0){
                          this.locations.push({text:city.city_name,value:city.city_id, s_id:city.state_id,group:element.state_name})
                      }
                  });
              });
          });
    },
    getCourses: async function () {
        await new this.$apiAction().getCourse().then(async (data) => {
        this.courses.push({header: 'Popular Courses'})
        await data.courses.forEach((element) => { 
            if((element.popular_rating == 1&&element.course_id<5000 && element.course_id != 37)||(element.popular_rating == 1 &&element.course_id == 5013)){
                this.courses.push({text:element.course_name,value:element.course_id,group:'Popular Courses'})
            }
        });
        this.courses.push({divider:true})
        this.courses.push({header: 'PG Courses'});   
        await data.courses.forEach((element) => {  
            if((element.popular_rating == 0 && element.course_type == 'pg'&&element.course_id<5000 && element.course_id != 37) || (element.popular_rating == 0 && element.course_type == 'pg'&&element.course_id == 5013)){
                this.courses.push({text:element.course_name,value:element.course_id,group:'PG Courses'})
            }
        });
        this.courses.push({divider:true})
        this.courses.push({header: 'Graduation Courses'});   
        await data.courses.forEach((element) => {  
            if((element.popular_rating == 0 && element.course_type == 'graduation'&&element.course_id<5000 && element.course_id != 37) || (element.popular_rating == 0 && element.course_type == 'graduation'&&element.course_id == 5013)){
                this.courses.push({text:element.course_name,value:element.course_id,group:'Graduation Courses'})
            }
        });
        this.courses.push({divider:true})
        this.courses.push({header: 'Other Category'});   
        await data.courses.forEach((element) => {  
            if((element.popular_rating == 0 && element.course_type == 'others_category'&&element.course_id<5000 && element.course_id != 37) || (element.popular_rating == 0 && element.course_type == 'others_category'&&element.course_id == 5013)){
                this.courses.push({text:element.course_name,value:element.course_id,group:'Other Category'})
            }
        });
        });
    },
    getJobrole(){
      new this.$apiAction().getJobrole().then(res => {
        if(res.jobroles.length > 0){
          this.jobroles = res.jobroles;
        }
      })
    },
    loadYears() {
        let currentYear = new Date().getFullYear();
        let min = currentYear - 10;
        let max = currentYear + 5
        for(let i = min; i <= max; i++) {
            this.years.push({ value: i, text: i});
        }
    },
    getApplicantAssessments: function(uid, status) {
      this.assess_modal_title = status ? 'Assessment score' : 'Assessment sent'
      var token = this.$cookies.get("hire-employer").token;
      new this.$apiAction().getAssessmentDetails(uid, status, token).then(res => {
        this.assess_details = res.assessments;
        this.$bvModal.show('view-assessment');
      })
    },
    openAssessmentPopup: function(){
      if(this.recipients[0].length > 0){
        this.$bvModal.show('assessment-template-modal');
      } else this.showMsgPopup('Select atleast 1 applicant to send assessment invite');
    },
    getEmailQuota: function(){
      var token = this.$cookies.get("hire-employer").token;
      new this.$apiAction().getFeatureQuota(1, token).then(res => {
        if(res.status) {
          this.email_remaining = res.remaining_total;
        }
      });
    },
    getContactQuota: function(){
      var token = this.$cookies.get("hire-employer").token;
      new this.$apiAction().getFeatureQuota(process.env.VUE_APP_JOB_CONTACT_VIEW_FEATURE_ID, token).then(res => {
        if(res.status) {
          this.contact_remaining = res.remaining_total;
          this.high_usage = res.high_usage;
        }
      });
    },
    select_All(e){
        if(e == true)
        {
          this.$refs.index.forEach((val, index) => this.selected[parseInt(index)+parseInt(this.offset)] = true)
          this.selected = JSON.parse(JSON.stringify(this.selected));
        } else {
            this.$refs.index.forEach((val, index) => this.selected[parseInt(index)+parseInt(this.offset)] = false)
            this.selected = JSON.parse(JSON.stringify(this.selected));
        }
    },
    getSelected: function(e, index){
        this.selected[index] = e.target.checked;
        this.selected = JSON.parse(JSON.stringify(this.selected));
    },
    getAssessmentStatus(invite, status) {
        if(invite) {
          let st_arr = invite.split(',');
          if(st_arr.includes(status.toString())) return true;
          else return false;
        }
      },
    handlePageChange(value) {
        this.page = value;
        this.offset = this.limit * (this.page - 1);
        this.loadResponses();
        this.selectAll = false;
        this.selected = JSON.parse(JSON.stringify(this.selected));
    },
    filterStatus(status_id, tab) {
      this.current_tab = tab;
      this.req.starred = null;
      this.req.status = status_id; this.loadResponses();
    },
    getStarred() {
      this.current_tab = 'starred';
      this.req.starred = 1; this.loadResponses();
    },
    loadResponses() {
      var emp_token = this.$cookies.get("hire-employer").token;
        this.req.offset = this.offset;
        this.req.limit = this.limit;
        if(this.visume_filter) this.req.visume = 1;
        if(this.jobfair_src) this.req.jobfair_src = 'jobfair';
          new this.$apiAction().getResponses(this.$route.params.job, this.req, emp_token).then(res => {
            this.job_responses = res.meta.response_count;
            this.dbmatch_profiles = res.meta.db_match_count;
            // this.limit = res.meta.limit;
            this.offset = res.meta.offset;
            this.no_applied = res.meta.applied || 0;
            this.no_shortlisted = res.meta.shortlisted || 0;
            this.no_interviewed = res.meta.interviewed || 0;
            this.no_joined = res.meta.joined  || 0;
            this.no_offered = res.meta.offered  || 0;
            this.no_rejected = res.meta.rejected  || 0;
            this.no_starred = res.meta.starred  || 0;
            this.total_count = this.no_applied + this.no_shortlisted + this.no_interviewed+ this.no_joined+this.no_rejected+this.no_offered;
            this.length = Math.ceil(this.job_responses/this.limit);
            this.jf_application_count = res.meta.jf_application_count;
            this.job = res.data.job;
            this.responses = res.data.responses;
            this.response_data = res.data.responses;
            this.responses.forEach(response => {
              this.$set(response, 'hide_comment', true);
              this.$set(response, 'edit_comment', false);
              this.$set(response, 'comment_text', response.comment);
              this.getGender(response);
              this.getAge(response);
            })
          });
    },
    getGender(response){
        this.gender.options.forEach(g =>{
          if(response.gender == g.value){
            response.gender= g.text
          }
        })
    },
    updateStatus(event, id) {
      let value = event.target.value;
      var emp_token = this.$cookies.get("hire-employer").token;

      new this.$apiAction().updateApplicationStatus(id, value, emp_token).then((res) => {
        if (res == 1) {
          this.loadResponses();
          this.$bvModal.show("update-success");
          setTimeout(() => {
            this.$bvModal.hide("update-success");
          },1000)
        }	
      })
    },
    getAge(response){
      if(response.dob) {
        let date1 = new Date(response.dob)
        let date2 = new Date()
        var year_diff = date2.getFullYear()-date1.getFullYear();
        response.age = year_diff;
      } else response.age = null
    },
    viewContact(response){
      this.contact = {};
      var token = this.$cookies.get("hire-employer").token;
      if(this.contact_remaining !== 0) {
        this.contact_loading = true;
        var data = {user_id: response.candidate_id,client_user_id:this.employer.client_users.client_user_id, view_type:1, job_id:this.job.job_id}
        new this.$apiAction().viewContact(data,token).then(res => {
          this.contact = res.contact;
          this.contact.name = response.candidate_name;
          this.contact_loading = false;
          if(res.remaining_total) this.contact_remaining = res.remaining_total;
        })
      }else{
        this.responses = this.response_data;
        this.job_responses = this.responses.length;
        this.length = Math.ceil(this.job_responses/this.limit);
      }
      this.openModal('view')
      this.getContactQuota();
    },
    viewQuestionnare(data) {
      this.loading = true;
      var emp_token = this.$cookies.get("hire-employer").token;
      var request = {uid:data.candidate_id,job_id:data.job_id};
      new this.$apiAction().getQuestionnaireResults(request,emp_token).then(res => {
        this.loading = false;
        if(res.results.length > 0){
          this.questionnaire_results = res.results;
          if(this.questionnaire_results.length > 0){
            this.questionnaire_results.forEach(result => {
              if(result.qp_id != null && result.question_type == 5){
                if(result.qp_id == 4 || result.qp_id == 23){
                  new this.$apiAction().getStates().then(data => {
                    data.states.forEach(state => {
                      state.cities.forEach(city => {
                        if(city.city_id == result.ans_id){
                          result.answer_text = city.city_name;
                        }
                      })
                    })
                  });
                }else if(result.qp_id == 15){
                  new this.$apiAction().getCourse().then(data => {
                    data.courses.forEach(course => {
                      if(result.ans_id == course.course_id){
                        result.answer_text = course.course_name;
                      }
                    });
                  });
                }
                // else if(result.qp_id == 7){
                //   new this.$apiAction().getLanguages().then(data => {
                //     console.log(data);
                //   })
                // }
                else if(result.qp_id == 21){
                  let experiences = [
                          { id : 1, text: "0 Month(Fresher)" },
                          { id : 6, text: "06 Months" },
                          { id : 12, text: "1 Year" },
                          { id : 24, text: "2 year" },
                          { id : 36, text: "3 year" },
                          { id : 48, text: "4 year" },
                          { id : 60, text: "5 year" },
                          { id : 72, text: "6 year" },
                          { id : 84, text: "6+ year" },
                        ];
                  experiences.forEach(exp => {
                    if(exp.id == result.ans_id){
                      result.answer_text = exp.text;
                    }
                  })
                }else if(result.qp_id == 2){
                  let jobrole = result.answer_text.split(",");
                  let answer = [];
                    if(this.jobroles.length > 0){
                      this.jobroles.forEach(role => {
                        jobrole.forEach(j_role => {
                          if(parseInt(j_role) == role.role_id){
                            answer.push(role.role);
                          }
                        });
                      });
                    }
                  result.answer_text = answer.toString();
                }
              }
            });
          }
        }else{
          this.questionnaire_results = [];
        }
      }).catch((err) => {
        this.loading = false;
        console.log(err);
      })
      this.openModal('questionnare');
    },
    getVisume(response){
      this.contact.visume_path = response.video_resume_path;
      // video.load();
      this.openModal('visume');
      // var source = document.getElementById('video_resume')
      // console.log(source);
      // source.setAttribute('src', response.video_resume_path);
    },
    modalId(i) {
      return 'visume_mode' + i;
    },
    downloadResponses: async function() {
      if(this.contact_remaining != 0) {
        if(this.recipients[0].length > 0){
          let selected_ids = []; 
          let downloadData = [];
          let candidate_ids = [];
          this.selected.forEach((id, index) => { if(id == true) { selected_ids.push(index)} } )
          await this.responses.forEach((response, index) => {
            if(selected_ids.includes(index)) {
              candidate_ids.push(response.candidate_id);
            }
          });
          var token = this.$cookies.get("hire-employer").token;
          if(candidate_ids.length > 0) {
          let req = {
              id: candidate_ids,
              job_id: this.job.job_id
            }
            await new this.$apiAction().downloadResponse(req, token).then(res => {
                if(res.status) {
                  let experiences = [
                          { id : 1, text: "0 Month(Fresher)" },
                          { id : 6, text: "06 Months" },
                          { id : 8, text: "08 Months" },
                          { id : 12, text: "1 Year" },
                          { id : 24, text: "2 year" },
                          { id : 36, text: "3 year" },
                          { id : 48, text: "4 year" },
                          { id : 60, text: "5 year" },
                          { id : 72, text: "6 year" },
                          { id : 84, text: "6+ year" },
                        ];
                  res.data.forEach(entry => {
                    if(entry.job_role){
                      const filteredRoles = this.jobroles.filter((obj) => JSON.parse(entry.job_role).includes(obj.role_id));
                      entry.job_role = (filteredRoles.map((obj) => obj.role)).join();
                    }

                    if(entry.total_experience  != 0){
                      entry.total_experience =  experiences.find((item) => item.id === entry.total_experience).text;
                    }
                    if(entry.resume_path){
                      entry.resume_path = this.$S3_bucket_url + entry.resume_path;
                    }
                    if(entry.video_resume_path){
                      entry.video_resume_path = this.$S3_bucket_url + entry.video_resume_path;
                    }
                    const headers = ["candidate_id","candidate_name",
                    "email","mobile","role","course_name","branch_name","aggregate_marks","passout_year","job_role",
                    "city_name","sublocation_name","age","dob","resume_path","total_experience","video_resume_path","application_status",
                    "contact_viewed_status","applied_date","application_id","src","questionnare"]
                    let xlsx_headers;
                    if(entry.questionnaire != null){
                      for (let key in entry.questionnaire) {
                          if (Object.prototype.hasOwnProperty.call(entry.questionnaire, key)) {
                              entry.questionnaire[key] = entry.questionnaire[key].replace('$S3_bucket_url', this.$S3_bucket_url);
                          }
                      }
                      const questionnaireKeys = Object.keys(entry.questionnaire);
                      xlsx_headers = headers.concat(questionnaireKeys);
                    }else{
                      xlsx_headers = headers
                    }
                    
                    Object.assign(entry, entry.questionnaire);
                    delete entry.questionnaire;
                    let r = JSON.parse(JSON.stringify( entry, xlsx_headers , 4));
                    r["application_status"] = this.getStatus(r["application_status"]);
                    downloadData.push(r);
                  })
                  this.contact_remaining = res.balance;
                  const data = XLSX.utils.json_to_sheet(downloadData);
                  const wb = XLSX.utils.book_new()
                  XLSX.utils.book_append_sheet(wb, data, 'data')
                  XLSX.writeFile(wb,'Jobresponses-hireclap.xlsx')
                } else {
                  this.showMsgPopup(res.message);
                }
            })
          }
        } else this.showMsgPopup('Select atleast 1 contact to download');
      } else {
          this.$bvModal.show('download-subscribe');
      }
    },
    openEmailPopup: function(){
      if(this.email_remaining > 0) {
        if(this.recipients[0].length > 0){
          this.$bvModal.show('email-template-modal');
        } else this.showMsgPopup('Select atleast 1 applicant to send an email');
      } else {
        this.$bvModal.show('email-subscribe');
      }
    },
    showMsgPopup(value) {
        this.boxOne = ''
        this.$bvModal.msgBoxOk( value, {
            buttonSize: 'sm',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true
          });
    },
    getDateWithTime(ts) {
      var months = ['Jan', 'Feb' , 'Mar' , 'Apr' , 'May' , 'June' , 'July' , 'Aug' , 'Sep' , 'Oct' , 'Nov' , 'Dec' ];

      var timestamp = ts * 1000;
      var date = new Date(timestamp);
      return date.getDate()+
            " "+months[date.getMonth()]+
            " "+date.getFullYear() +
            ", "+ date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
              
    },
    pad(n){
    if(n < 10) return '0'+n; else return n;
    },
    getStatus(status) {
      switch(status) {
        case 0: return 'Applied';
        case 1: return 'Shortlisted';
        case 2: return 'Interviewed';
        case 3: return 'Offered';
        case 4: return 'Rejected';
        case 5: return 'Joined'; 
        default: break;
      }
    },
    getExp(exp){
      var experience= ''
      
      if(exp == 0){
        experience="0";
      }else if(exp > 0 && exp < 12 ){	
        experience = exp+" Months";
      }else if(exp == 84){		
        experience="6+ Years";
      }else{		
        experience=(exp / 12)+" Years";
      }		
      return experience;
    },
    dealBreakerQuestions(){
      var token = this.$cookies.get("hire-employer").token;
      new this.$apiAction().getDealBreakerQuestions(this.$route.params.job,token).then(res => {
        this.dealBreaker = res.results;
      });
    },
    applyQuestionnaireFilter(){
      if(this.deal){
        var token = this.$cookies.get("hire-employer").token;
        var data = {'qid':this.deal,'job_id':this.$route.params.job}
        new this.$apiAction().submitDealFilter(data,token).then(res => {
          this.responses = this.response_data;
          if(res.results.length){
            this.responses = this.response_data.filter(response => {
              return res.results.some(result => {
                return result.uid === response.candidate_id;
              })
            })
            this.job_responses = this.responses.length;
            this.length = Math.ceil(this.job_responses/this.limit);
          }else{
            this.responses = [];
            this.job_responses = this.responses.length;
            this.length = Math.ceil(this.job_responses/this.limit);
          }
        })
      }else{
        this.responses = this.response_data;
        this.job_responses = this.responses.length;
        this.length = Math.ceil(this.job_responses/this.limit);
      }
    }
  }
}
</script>